import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function BrokersCreate() {
  const { user } = useContext(AuthContext);
  const URL_BROKERS = process.env.REACT_APP_URL_BROKERS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [datos, setDatos] = useState({ razonSocial: "", contacto: "", email: "", telefono: "" });
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
  const [t, i18n] = useTranslation("global");

  const clear = () => {
    setName("");
  };

  const saveBrokers = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_BROKERS,
        {
          name,
          ...datos,
          cargos:0,
          abonos:0,
          saldo:0
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Broker",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <Form onSubmit={saveBrokers}>
          <div className="form-section">
            <div className="form-section-header"><i className="fas fa-plus-circle" /><h4 className="form-section-title">Crea un nuevo Broker</h4></div>
            <div className="form-section-body">
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              Broker
            </Label>
            <Input
              type="text"
              name="email"
              
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </FormGroup>
          {[
            ["razonSocial", "Razón social"],
            ["contacto", "Contacto"],
            ["email", "Correo"],
            ["telefono", "Teléfono"],
          ].map(([k, l]) => (
            <FormGroup key={k} className="mb-2 mr-sm-2 mb-sm-0 mt-2">
              <Label className="mr-sm-2">{t(l)}</Label>
              <Input
                type={k === "email" ? "email" : "text"}
                value={datos[k]}
                required={k !== "contacto"}
                onChange={(e) => {
                  const v = e.target.value;
                  setDatos((d) => ({ ...d, [k]: v }));
                }}
              />
            </FormGroup>
          ))}
            </div>
          </div>
          <div className="submit-bar">
            {validaBoton ? (
              <Button type="submit" color="success">
                <i className="fas fa-save" /> {t("Guardar")}
              </Button>
            ) : (
              <Button type="submit" color="success" disabled>
                <i className="fas fa-save" /> {t("Guardar")}
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="secondary" href="/MenuCatalogos">
              <i className="fas fa-arrow-left" /> {t("Regresar")}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default BrokersCreate;
